export const socketTypes = {
  CONNECT: 'socket/CONNECT',
  SUCCESS: 'socket/CONNECT_SUCCESS',
  INIT: 'socket/INIT_DATA',
  SEND_MSG: 'socket/SEND_MESSAGE',
  NEW_MSG: 'socket/NEW_MESSAGE',
  UPDATE_MSG: 'socket/UPDATE_MSG',
  UPDATE_SESSION: 'socket/UPDATE_SESSION',
  SEND_NOTIF: 'socket/SEND_NOTIFICATION',
  NEW_NOTIF: 'socket/NEW_NOTIFICATION',
  REMOVE_NOTIF: 'socket/REMOVE_NOTIFICATION',
  NOTIF_UPDATE: 'socket/NOTIFICATION_UPDATE',
  REMOVED_FROM_TEAM: 'socket/REMOVED_FROM_TEAM',
  SET_ACTIVESESSION: 'socket/SET_ACTIVE_SESSION_ID',
  ADD_MSGS: 'socket/ADD_MSGS'
}

export const socketConnect = () => (
  {
    type: socketTypes.CONNECT
  }
)

export const socketSendMessage = (data) => (
  {
    type: socketTypes.SEND_MSG,
    data
  }
)

export const setActiveSessionId = (id) => (
  {
    type: socketTypes.SET_ACTIVESESSION,
    id
  }
)



// WEBPACK FOOTER //
// ./src/actions/socket.js